export const FeatureFlagName = {
  IMPORT_SOURCES: 'import_sources',
  MCP_TOOLING: 'mcp_tooling',
  RECIPE_MACROS_DISPLAY: 'recipe-macros-display',
} as const;

export type FeatureFlagName = (typeof FeatureFlagName)[keyof typeof FeatureFlagName];
